
<template>
    <div class="container1">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">客户名称：{{customerName}}</span>
				<!-- <el-input
					v-model=""
					disabled
					class="name-input"
					size="mini"
				></el-input> -->
			</div>
		</div>
		<div class="search-box">
            <div class="time-box">
                <el-select v-model="dateType" class="select-input" size='mini'>
                    <el-option :value="0" label="生效日期"></el-option>
                    <el-option :value="1" label="失效日期"></el-option>
                    <el-option :value="2" label="修改时间"></el-option>
										<el-option :value="3" label="新建时间"></el-option>
                </el-select>
                <el-date-picker
					v-model="dateValue"
					@change="timeChange"
					class="time-input"
					size="mini"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
          format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm:ss'>
				</el-date-picker>
            </div>
			<div class="input-box">
				<span>使用状态：</span>
				<el-select v-model="useStatus" class="select-box" size='mini'>
                    <el-option :value="0" label="全部"></el-option>
                    <el-option :value="1" label="使用中"></el-option>
                </el-select>
			</div>
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="pName"
					placeholder="请输入商品、规格名称"
					class="name-input"
                    @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
      <!-- <div class="input-box">
				<span>销售门店：</span>
				<el-input
					v-model="shopName"
					placeholder="请输入销售门店"
					class="name-input"
                    @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div> -->
			<div class="input-box">
				<span>SPU编号：</span>
				<el-input
					v-model="pcode"
					placeholder="请输入SPU编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box">
				<span>三方编号：</span>
				<el-input
					v-model="matchcode"
					placeholder="请输入三方编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box">
				<span>SKU编号：</span>
				<el-input
					v-model="speccode"
					placeholder="请输入SKU编号"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box" v-if="!(matchbillcenterflag === 1 && matchbillcenterpriceflag ==1)">
				<span>销售门店：</span>
				<el-select
					size="mini"
					class="name-input"
					popper-class="select"
					v-model="shopNameIds"
					filterable
					multiple
					collapse-tags
					placeholder="请选择门店名称">
					<template v-for="item in shopList">
						<el-option
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box">
				<span>新建人：</span>
				<el-input
					v-model="createUserName"
					placeholder="请输入新建人姓名"
					class="name-input"
          @keyup.enter.native="search"
					size="mini"
				></el-input>
			</div>
			<div class="input-box-btn">
				<el-button type='primary' plain size='mini' class="fx-btn" @click="search">查询</el-button>
			</div>
		</div>
		<div class="btn-price-box">
			<el-button v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' class="fx-big-btn" @click="addClick">添加商品</el-button>
			<el-button v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click='copyClick'>复制到其他客户</el-button>
			<el-button v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click='mutiCLick'>批量设置</el-button>
			<el-button v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click="deleteList" class="fx-big-btn">删除</el-button>
			<el-button v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click="deleteLists" class="fx-big-btn">批量删除</el-button>
			<div v-if='AuthorityList["03_0001_0011_00"]' class="batch-register-btn"  @click="downloadClick" >
				<i class="excel-icon import-excel-icon"/>
				<span>价格Excel导出</span>
			</div>

			<div v-if='AuthorityList["03_0001_0010_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' class="batch-register-btn" @click="fileClick">
				<i class="excel-icon import-excel-icon"/>
				<span>价格Excel导入</span>
			</div>
			<input type="file" ref="file" id="file" accept=".xlsx" v-show="false" @change="getFile">
		</div>
		<div class='table-box'>
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				border>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label="商品名称"
					prop='pname'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SPU编号"
					prop='pcode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="三方编号"
					prop='matchcode'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="规格名称"
					prop='spec'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SKU编号"
					prop='speccode'
					min-width="180"
					align="center">
				</el-table-column>
                <!-- <el-table-column
					label="销售门店"
					prop='shopname'
					min-width="180"
					align="center">
				</el-table-column> -->
                <el-table-column
					label="默认价格"
					prop='defaultprice'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="专用价格"
					prop='speprice'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="生效日期"
					prop='startdate'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="失效日期"
					prop='enddate'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="修改时间"
					prop='modifydate'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="使用状态"
					prop='useing'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="店铺名称"
					prop='shopname'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text'>{{scope.row.shopname}}</el-button>
					</template>
				</el-table-column>
				<el-table-column
					label="新建时间"
					prop='createDate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="新建人"
					prop='createUserName'
					min-width="180"
					align="center">
				</el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text' @click="show(scope.row)">查看</el-button>
						<el-button size="mini" type='text' v-if='!isDisabled && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' @click="deleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top:5px">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="page.num"
				:page-sizes="[20,40, 60, 100, 300]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
				</el-pagination>
			</div>
            <el-dialog class="detail-dialog-title" title="添加商品" top='60px' :before-close='closeAdd' :visible.sync="addModal" width='1400px' :close-on-click-modal="false">
                <addGood :addModal='addModal' :syscode='syscode' :customerName='customerName' @cancel='closeAdd'/>
            </el-dialog>

			<el-dialog class="detail-dialog-title" title="批量设置" top='60px' :before-close='cancelMuti' :visible.sync="mutiModel" width='500px' :close-on-click-modal="false">
				<Muti v-if='mutiModel' :ids='ids' :tableData="tableData" @cancel='cancelMuti'></Muti>
			</el-dialog>

            <el-dialog class="detail-dialog-title" title="批量删除" top='60px' :before-close='closeDelete' :visible.sync="deleteModal" width='500px' :close-on-click-modal="false">
                <BatchDeletion :deleteModal='deleteModal' :customerName='customerName' v-if="deleteModal" @cancel='closeDelete'/>
            </el-dialog>
			<el-dialog class="detail-dialog-title" title="复制到其他客户" top='60px' :before-close='closeCopy' :visible.sync="copyModal" width='1200px' :close-on-click-modal="false">
                <copy :copyModal='copyModal' :ppIds='ids' :syscode='syscode' :customerName='customerName' :copyFlag='copyFlag' @cancel='closeCopy' ref="refCopy"/>
            </el-dialog>
			<el-dialog class="detail-dialog-title" title="编辑" top='60px' :before-close='closeEdit' :visible.sync="editModal" width='500px' :close-on-click-modal="false">
                <Edit :editModal='editModal' :isDisabled='isDisabled' :customerName='customerName' :editData='editData' @cancel='closeEdit'/>
            </el-dialog>
			<el-dialog title="提示" class="detail-dialog-title" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;max-height:250px;overflow:auto">
				<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
					{{item}}
				</div>
			</div>
			<div style="width:100%;text-align: center;margin-top:10px">
				<el-button size="small" style="width:120px" plain type="primary" @click="errorMsgClick">确认</el-button>
			</div>
		</el-dialog>
		</div>
	</div>
</template>
<script>
import addGood from '@/components/customer/addGood.vue'
import copy from '@/components/customer/copy.vue'
import Edit from '@/components/customer/Edit.vue'
import Muti from '@/components/customer/Muti.vue'
import BatchDeletion from '@/components/customer/BatchDeletion.vue'
const tableHeight1 = 'calc(100% - 10px)'
export default {
	name: 'table-box',
	components: {
		addGood, copy, Edit, BatchDeletion, Muti
	},
	props: {
		id: String
	},
	data () {
		return {
			params: {},
			errorMsgModel: false,
			errorMsgList: [],
			customerName: '',
			isDisabled: true,
			startdate: '',
			enddate: '',
			addModal: false,
			deleteModal: false,
			copyModal: false,
			editModal: false,
			editData: '',
			dateValue: [],
			dateType: 0,
			useStatus: 0,
			name: '',
			shopName: '',
			pName: '',
			syscode: '',
			syscodeid: '',
			tableHeight: tableHeight1,
			page: {
				size: 20,
				num: 1
			},
			total: null,
			tableData: [],
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false
			},
			pcode: '',
			matchcode: '',
			speccode: '',
			matchbillcenterflag: 0,
			matchbillcenterpriceflag: 0,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			}),
			shopNameIds: [],
			shopList: [],
			mutiModel: false,
			copyFlag: 0,
			createUserName: ''
		}
	},
	created () {
		this.checkSmallCategory()
		this.customerName = window.sessionStorage.getItem('customerName')
		this.getAuthority('03_0001_0000_00')
		this.getCode()
		this.getShopList()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		cancelMuti (data) {
			this.mutiModel = false
			this.tableReload()
			if (data === 1) {
				this.tableSelectUtils.clear()
			}
		},
		mutiCLick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品！')
				return false
			}
			this.mutiModel = true
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id,
				pname: row.pname
			}
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
				this.matchbillcenterpriceflag = res.matchbillcenterpriceflag
			})
			// })
		},
		fileClick () {
			if (this.syscode === '') {
				this.$message.error('客户注册号不存在')
				return false
			}
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		getFile (e) {
			let files = e.target.files[0]
			console.log(files)
			this.uploadExcelHandle()
			this.$refs.file.value = ''
		},
		uploadExcelHandle () {
			let syscodeid = window.sessionStorage.getItem('syscodeid')
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerPriceExcel?syscodeid=` + syscodeid,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		downloadClick () {
			let syscodeid = window.sessionStorage.getItem('syscodeid')
			if (this.syscode === '') {
				this.$message.error('客户注册号不存在')
				return false
			}
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/exportCustomerDetailPriceExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let params = this.params
			params.syscodeid = syscodeid
			let list = this.initIds(this.ids)
			if (this.ids.length > 0) {
				params.priceIds = list
			} else {
				params.priceIds = []
			}
			params.id = window.sessionStorage.getItem('customerid')
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = '客户价格信息(' + year + '-' + month + '-' + day + ').xlsx'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		rowClick (row, column, event) {
			this.show(row)
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('isCustomerAdd')
					if (add === 'true') {
						if (this.AuthorityList['03_0001_0005_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['03_0001_0003_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		timeChange () {
			if (this.dateValue === null) {
				this.startdate = ''
				this.enddate = ''
			} else {
				this.startdate = this.dateValue[0]
				this.enddate = this.dateValue[1]
			}
		},
		closeEdit () {
			this.editModal = false
			this.tableReload()
		},
		closeAdd () {
			this.addModal = false
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		closeDelete () {
			this.deleteModal = false
			this.tableReload()
		},
		closeCopy () {
			this.copyModal = false
			this.$refs.refCopy.name = ''
			this.$refs.refCopy.lineName = ''
			this.$refs.refCopy.customercategoryid = -1
			this.$refs.refCopy.disabledflag = 2
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		copyClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品价格档案！')
				return false
			}
			this.copyFlag = 1
			this.copyModal = true
		},
		addClick () {
			this.addModal = true
		},
		deleteLists () {
			this.deleteModal = true
		},
		getCode () {
			let params = {
				id: window.sessionStorage.getItem('customerid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/findCustomerDetailInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.syscode = res.data.syscode + ''
					this.$nextTick(() => {
						this.tableReload()
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		show (data) {
			this.editModal = true
			this.editData = data
		},
		search () {
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		deleteClick (data) {
			let params = {
				spids: data.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerSpecialPrice`,
				data: params
			}).then(res => {
				// console.log(res)
				if (res.result) {
					this.tableReload()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteList (data) {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品价格档案！')
				return false
			}
			let list = this.initIds(this.ids)
			let params = {
				spids: list.join(',')
			}
			let pName = []
			this.ids.forEach(item => {
				pName.push(item.pname)
			})
			let changeData = {
				pre: { delete: {} },
				cur: { delete: { pName: pName, customerName: this.customerName } }
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerSpecialPrice`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.tableReload()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initIds (data) {
			let list = []
			data.forEach(item => {
				list.push(item.id)
			})
			return list
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		tableReload () {
			let params = {
				useStatus: this.useStatus,
				dateType: this.dateType,
				syscode: this.syscode,
				startdate: this.startdate,
				enddate: this.enddate,
				shopname: this.shopName,
				productname: this.pName,
				page: this.page.num,
				size: this.page.size,
				pcode: this.pcode,
				matchcode: this.matchcode,
				speccode: this.speccode,
				createUserName: this.createUserName,
				relShopIdList: this.shopNameIds
			}
			this.params = params
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getProductOfSpecialPrice`,
				data: params
			}).then(res => {
				console.log(res)
				if (res.result) {
					this.tableData = res.data.recordList
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
					})
					if (res.data.recordList !== null) {
						this.tableData.forEach(item => {
							item.defaultprice = this.$fxUtils.toFixedSHW(item.defaultprice, 2)
							item.speprice = this.$fxUtils.toFixedSHW(item.speprice, 2)
						})
					}
					this.total = +res.data.recordCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
				// console.log(res)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	// min-width: 730px;
	width: 100%;
	flex-direction: column !important;
	height:calc(100% - 20px) ;
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
        display: flex;
        width: 100px;
        height: 32px;
        justify-content center;
        align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.search-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box-btn{
			width :80px;
		}
        .select-input{
                width :120px
            }
            .time-input{
                margin-left 10px
                width :320px
            }
        .time-box{
			text-align :left
            width :460px;
			margin-bottom:10px
			margin-right:10px

        }
		.input-box{
			text-align :left
			width :280px;
			margin-bottom:10px
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.btn-price-box{
		margin-top:10px;
		display :flex
	}
	.table-box{
		height :calc(100% - 260px)
		margin-top:8px;
		min-height:200px;
	}
}

</style>
<style lang="stylus">
.el-dialog__header{
    text-align left
}
.el-dialog__body {
	padding: 10px 20px 10px 20px;
}
.select {
	min-width: 280px !important
}
</style>
